import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, mergeMap } from "rxjs/operators";

import { fromPromise } from "rxjs/observable/fromPromise";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { ChildAbstractModel } from "../../../_models/child-abstract-model";
import { ReceiptManagementService } from "../../../_services/receipt-management.service";
import { UserAbstractModel } from "../../../_models/user-abstract-model";

@Component({
  selector: "receipt-page-search-receipt-issuer",
  templateUrl: "./receipt-page-search-receipt-issuer.component.html",
  styleUrls: [
    "../receipt-page-search-child/receipt-page-search-child.component.scss",
    "receipt-page-search-receipt-issuer.component.scss",
  ],
})
export class ReceiptPageSearchReceiptIssuerComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("resultTemplate") public resultTemplate;
  @ViewChild("autoCompleteInput") public autoCompleteInput: ElementRef;
  public translations$: Observable<ITranslations>;
  @Output("childSelected")
  public childSelectedEvent: EventEmitter<UserAbstractModel | null> = new EventEmitter<UserAbstractModel | null>();
  public selectedIssuer: UserAbstractModel | null = null;

  constructor(
    private modalService: NgbModal,
    private receiptManagementService: ReceiptManagementService,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {}

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(
          this.receiptManagementService.searchReceiptIssuerByText(term)
        );
      })
    );

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public childSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    const userSelected = $event.item as UserAbstractModel;
    this.selectedIssuer = userSelected;
    this.childSelectedEvent.emit(userSelected);
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  public cancelSelectedChild() {
    this.selectedIssuer = null;
    this.childSelectedEvent.emit(null);
    this.autoCompleteInput.nativeElement.value = "";
  }
  public searchBoxKeyDown($event: KeyboardEvent) {
    if (!this.selectedIssuer) {
      return;
    }
    if ($event.key === "Backspace" || $event.key === "Delete") {
      this.cancelSelectedChild();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page-search-receipt-issuer/receipt-page-search-receipt-issuer.component.ts